import React, {useEffect, useCallback, useState} from 'react';
import _ from 'lodash';
import Checkbox from "../../../../../components/checkbox";
import {useList} from "react-use";

import {Collapse} from 'react-collapse';

function HittingDirection(props) {
    const [isOpened, setIsOpened] = useState(false);
    const {selected} = props;
    const [hittingDirection, setHittingDirection] = useState({
        "3div": selected['3div'],
        "5div": selected['5div'],
    });
    const [list3div, list3divHelper] = useList([
        {
            value:  1,
            name: '左',
            checked: false
        },{
            value:  2,
            name: '中',
            checked: false
        },{
            value:  3,
            name: '右',
            checked: false
        },
    ]);
    const [list5div, list5divHelper] = useList([
        {
            value:  1,
            name: '右',
            checked: false
        },{
            value:  2,
            name: '左中',
            checked: false
        },{
            value:  3,
            name: '中',
            checked: false
        },{
            value:  4,
            name: '右中',
            checked: false
        },{
            value:  5,
            name: '右',
            checked: false
        },
    ]);
    useEffect(() => {
        if(selected['3div'].length > 0)
        selected['3div'].map(item => {
            const index = list3div.findIndex(i => i.value === item);
            list3div[index].checked = true;
        })
        if(selected['5div'].length > 0)
            selected['5div'].map(item => {
                const index = list5div.findIndex(i => i.value === item);
                list5div[index].checked = true;
            })
    },[selected])
    useEffect(() => {
        props.onChange(hittingDirection)
    },[hittingDirection]);

    const onChange3Divisions = useCallback((value, i) => {
        list3divHelper.updateAt(i, {...list3div[i], checked: !list3div[i].checked})
        const arr = [...hittingDirection['3div']];
        const index = _.indexOf(arr, value);
        if (index === -1) {
            arr.push(value)
        } else {
            arr.splice(index, 1);
        }
        setHittingDirection(state => ({...state, ['3div']: arr}))
    },[hittingDirection['3div']]);

    const onChange5Divisions = useCallback((value, i) => {
        list5divHelper.updateAt(i, {...list5div[i], checked: !list5div[i].checked})
        const arr = [...hittingDirection['5div']];
        const index = _.indexOf(arr, value);
        if (index === -1) {
            arr.push(value)
        } else {
            arr.splice(index, 1);
        }
        setHittingDirection(state => ({...state, ['5div']: arr}))
    },[hittingDirection['5div']]);
    return (
        <div className='inner-item-child group-filter-item'>
            <div className={'open-collapse'}>
                <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                    <h4>打球方向</h4>
                    <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
                </div>
                <Collapse  isOpened={isOpened}>
                    <div>
                        <div>
                            <p className="smallTitle">3分割</p>
                            <div className="wrap-group">
                                {list3div.map((item, index) => {
                                    return (
                                        <div key={item.value} className='search-main-advanced-checkbox'>
                                            <label>
                                                <Checkbox checked={item.checked} onClick={() => onChange3Divisions(item.value, index)}/>
                                                {item.name}
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div>
                            <p className="smallTitle">5分割</p>
                            <div className="wrap-group">
                                {list5div.map((item, index) => {
                                    return (
                                        <div key={item.value} className='search-main-advanced-checkbox'>
                                            <label>
                                                <Checkbox checked={item.checked} onClick={() => onChange5Divisions(item.value, index)}/>
                                                {item.name}
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>
            <div className={'close-collapse'}>
                <div>
                    <h4>打球方向</h4>
                </div>
                    <div>
                        <div>
                            <p className="smallTitle">3分割</p>
                            <div className="wrap-group">
                                {list3div.map((item, index) => {
                                    return (
                                        <div key={item.value} className='search-main-advanced-checkbox'>
                                            <label>
                                                <Checkbox checked={item.checked} onClick={() => onChange3Divisions(item.value, index)}/>
                                                {item.name}
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div>
                            <p className="smallTitle">5分割</p>
                            <div className="wrap-group">
                                {list5div.map((item, index) => {
                                    return (
                                        <div key={item.value} className='search-main-advanced-checkbox'>
                                            <label>
                                                <Checkbox checked={item.checked} onClick={() => onChange5Divisions(item.value, index)}/>
                                                {item.name}
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    )
}

export default HittingDirection;
